<template>
  <div class="banner">
    <div class="banner-image">
      <img :src="bannerSrc" alt="Banner" />
    </div>
    <div class="banner-dots">
      <span
        v-for="(dot, index) in bannerImages.length"
        :key="index"
        :class="{ active: activeDot === index }"
        @click="changeBanner(index)"
      ></span>
    </div>

    <!-- <div class="banner-image" v-for="(img, index) in bannerImages" :key="index">
      <img :src="img.src" alt="Banner" />
    </div>
    <div class="dot-container">
      <span
        class="dot"
        v-for="(img, index) in bannerImages"
        :key="index"
        :class="{ active: activeIndex === index }"
        @click="changeBanner(index)"
      >
      </span>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeDot: 0, // 当前激活的小点索引
      bannerImages: [
        // Banner图片列表
        require("@/assets/banner1.jpg"),
        require("@/assets/banner2.jpg"),
        require("@/assets/banner3.jpg"),
      ],
      bannerSrc: require("@/assets/banner1.jpg"), // 当前显示的Banner图片
    };
  },
  mounted() {
    // 使用setInterval每隔几秒更新当前的Banner图片和小点
    setInterval(() => {
      this.activeDot = (this.activeDot + 1) % this.bannerImages.length;
      this.bannerSrc = this.bannerImages[this.activeDot];
    }, 3000); // 时间间隔可以根据需要调整
  },
  methods: {
    changeBanner(index) {
      this.activeDot = index; // 切换到指定的banner
      this.bannerSrc = this.bannerImages[this.activeDot];
    },
  },
};
</script>

<style scoped>
.banner {
  position: relative;
  overflow: hidden;
}
.banner-image img {
  width: 66%;
  height: 320px;
}
.banner-dots {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.banner-dots span {
  display: inline-block;
  width: 50px;
  height: 6px;
  border-radius: 1em;
  background-color: #0850fc;
  margin: 0 5px;
  opacity: 0.3;
  transition: opacity 0.3s;
  cursor: pointer;
}
.banner-dots .active {
  opacity: 1;
}

/* .banner-image img {
  width: 100%;
  height: auto;
}
.dot-container {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ccc;
  margin: 0 5px;
  cursor: pointer;
}
.dot.active {
  background-color: #333;
} */
</style>



// WEBPACK FOOTER //
// src/views/index/Banner.vue